import React from 'react'
import { LanguageSelector } from './components/LanguageSelector/LanguageSelector'
import { HeroImage } from './components/HeroImage/HeroImage'
import { Form } from './components/Form/Form'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './AuthPage.module.scss'

export const AuthPage = () => {
  useAnalytics('visit_welcome_screen_onboarding_app', true)

  return (
    <div className={styles.PageContainer}>
      <LanguageSelector />
      <HeroImage />
      <Form />
    </div>
  )
}
